"use strict";

exports.__esModule = true;
exports.Head = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("../../theme"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Head = ({
  title,
  description,
  font,
  resetCss,
  fullHeightCss,
  customCss
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactHelmet.Helmet, {
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), description && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      name: "description",
      content: description
    }), font && /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
      href: font,
      rel: "stylesheet"
    }), resetCss && /*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: resetCss
    }), fullHeightCss && /*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: fullHeightCss
    }), customCss && /*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: customCss
    })]
  });
};

exports.Head = Head;
Head.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  resetCss: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  fullHeightCss: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  customScrollbars: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  customCss: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  font: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool])
};
Head.defaultProps = {
  resetCss: `
    *, *::before, *::after {
        box-sizing: border-box;
    }

    html {
        font-family: sans-serif;
        line-height: 1.15;
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }

    body {
        background-color: ${_theme.default.colors.body.background};
        margin: 0;
        height: inherit;
        color: ${_theme.default.colors.primaryText};
        font-family: ${_theme.default.fonts.sansSerif};
    }

    [tabindex="-1"]:focus {
        outline: 0 !important;
    }

    button, input, optgroup, select, textarea {
        font-family: inherit;
        font-size: inherit;
    }

    .rui-tooltip.rui-tooltip--standard {
        color: ${_theme.default.colors.tooltip.text};
        background-color: ${_theme.default.colors.tooltip.background};
        border-radius: ${_theme.default.borderRadius.small};
    }

    .rui-tooltip.rui-tooltip--standard.place-top:after {
        border-top-color: ${_theme.default.colors.tooltip.background};
    }

    .rui-tooltip.rui-tooltip--standardplace-bottom:after {
        border-bottom-color: ${_theme.default.colors.tooltip.background};
    }

    .rui-tooltip.rui-tooltip--standard.place-left:after {
        border-left-color: ${_theme.default.colors.tooltip.background};
    }

    .rui-tooltip.rui-tooltip--standard.place-right:after {
        border-right-color: ${_theme.default.colors.tooltip.background};
    }

    .rui-tooltip.rui-tooltip--inverted {
        color: ${_theme.default.colors.tooltip.inverted ? _theme.default.colors.tooltip.inverted.text : _theme.default.colors.tooltip.text};
        background-color: ${_theme.default.colors.tooltip.inverted ? _theme.default.colors.tooltip.inverted.background : _theme.default.colors.tooltip.background};
        border-radius: ${_theme.default.borderRadius.small};
    }

    .rui-tooltip.rui-tooltip--inverted.place-top:after {
        border-top-color: ${_theme.default.colors.tooltip.inverted ? _theme.default.colors.tooltip.inverted.background : _theme.default.colors.tooltip.background};
    }

    .rui-tooltip.rui-tooltip--inverted.place-bottom:after {
        border-bottom-color: ${_theme.default.colors.tooltip.inverted ? _theme.default.colors.tooltip.inverted.background : _theme.default.colors.tooltip.background};
    }

    .rui-tooltip.rui-tooltip--inverted.place-left:after {
        border-left-color: ${_theme.default.colors.tooltip.inverted ? _theme.default.colors.tooltip.inverted.background : _theme.default.colors.tooltip.background};
    }

    .rui-tooltip.rui-tooltip--inverted.place-right:after {
        border-right-color: ${_theme.default.colors.tooltip.inverted ? _theme.default.colors.tooltip.inverted.background : _theme.default.colors.tooltip.background};
    }
    `,
  fullHeightCss: `
    html {
        height: 100%;
    }

    body {
        height: 100%;
    }

    body > #root {
        height: 100%;
    }
    `,
  customCss: null,
  font: 'https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700&display=swap'
};